import Vue from 'vue'
import Vuex from 'vuex'

import bis from './bis/index.js'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    bis
  }
})
